import { AcceptArgs, AcceptVariables } from './queryVariables/accept';
import { Resource } from './resource';

/**
 * Resource akceptacji zaproszeń
 *
 * @export
 * @class AcceptResource
 * @extends {Resource}
 */
export class AcceptResource extends Resource {
  /**
   * Akceptuje zaproszenie
   *
   * @param {string} token
   * @returns {Promise<boolean>}
   * @memberof AcceptResource
   */
  public accept(type: string, token: string): Promise<string> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: AcceptVariables,
        [type + 'Accept']: { __args: AcceptArgs }
      }
    });
    return this.mutation({ mutation, variables: { token } }, type + 'Accept');
  }
}

export const acceptResource = new AcceptResource();
